module.exports = __webpack_public_path__ + "static/media/Temetlogo.5fd6150a.jpg";